<template>
    <th class="radio">
        <!-- nothing in the header -->
    </th>
</template>
<script>
export default {
    name: 'RadioColumn',
    model: {
        prop: 'checked',
        event: 'update:checked',
    },
    props: ['checked'],
    inject: ['table'],
    mounted() {
        this.table.updateColumns()
    },
    beforeDestroy() {
        this.table.updateColumns()
    },
    methods: {
        renderTableCell(value) {
            const h = this.$createElement
            const checked = this.checked === value
            return h(
                'td',
                {
                    class: 'radio',
                    on: {
                        click: function (event) {
                            event.stopPropagation()

                            // redirect clicks to the checkbox
                            if (event.target == event.currentTarget) {
                                event.currentTarget.querySelector('input').click()
                            }
                        },
                    },
                },
                [
                    h('input', {
                        attrs: { type: 'radio' },
                        domProps: {
                            checked,
                            value,
                        },
                        on: { input: event => this.onChecked(event, value) },
                    }),
                ]
            )
        },
        onChecked(event, value) {
            event.target.checked = !event.target.checked
            this.$emit('update:checked', value)
        },
    },
}
</script>
<style>
.mt-table td.radio,
.mt-table th.radio {
    border-right: none;
    padding-right: 0;
    width: 32px;

    & input::before {
        top: -10px;
    }

    & + td {
        padding-left: 8px;
    }
}
</style>
